<h5> {{ this.companyLeadLabelConfiguration.label ?? "Lead" | translate }} </h5>

<app-lead-list [configuration]="configuration" [importComponent]="true"></app-lead-list>
